import { render, staticRenderFns } from "./ItemKapufa7m.vue?vue&type=template&id=88759d40&scoped=true&"
import script from "./ItemKapufa7m.vue?vue&type=script&lang=js&"
export * from "./ItemKapufa7m.vue?vue&type=script&lang=js&"
import style0 from "./ItemKapufa7m.vue?vue&type=style&index=0&id=88759d40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88759d40",
  null
  
)

export default component.exports